import React, { useCallback, useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import MIXTLogo from '../../../assets/images/logo.png';
import Loader from '../../../components/common/Loader';
import { GLOBAL_DEFAULT } from '../../../constants/global';
import { orderService } from '../services';
import Barcode from 'react-barcode';
import SvgIcons from '../../../components/common/SvgIcons';
import { MdInventory2 } from 'react-icons/md';

const PrintPickList: React.FC<any> = () => {
    const [state, setState] = useState<any>(null);
    const [summaryPickList, setSummaryPickList] = useState<any[]>([]);
    const [orderPickList, setOrderPickList] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(GLOBAL_DEFAULT.LOADER_STATE);

    useEffect(() => {
        try {
            const windowName = window.name;
            const state = JSON.parse(windowName);

            setState(state);
        } catch (error) {
            console.error('Failed to parse state from window name', error);
            window.location.href = '/app/dashboard';
        }
    }, []);

    const getOrderDetails = useCallback(async () => {
        if (state?.orderId) {
            setLoading(true);
            try {
                const payload = {
                    orderIds: state.orderId
                }
                const response = await orderService.printPickList(payload);

                setSummaryPickList(response?.data?.summary_pick_list || []);
                setOrderPickList(response?.data?.order_pick_list || []);
                setLoading(false);
            } catch (error) {
                setLoading(false);
            }
        }

    }, [state?.orderId]);

    useEffect(() => {
        getOrderDetails();

    }, [getOrderDetails]);

    return <>
        <Loader isLoading={loading} />
        <div className='text-center hide-on-print pt-3 '><Button className='custom-min-width-85' size='sm' variant="dark" onClick={() => window.print()}>Print</Button></div>
        <div style={{ pageBreakAfter: 'auto' }}>
            <table
                aria-hidden="true"
                style={{
                    fontFamily: '"Source Sans Pro", sans-serif',
                    fontSize: 14,
                    color: "#000000",
                    margin: "10px auto",
                    padding: 0,
                    width: "100%",
                    background: "#FFFFFF",
                    textAlign: "left",
                    borderCollapse: "collapse",
                    border: "1px solid #CCCCCC",
                    maxWidth: "700px",
                    wordBreak: "break-word"
                }}
            >
                <tbody>
                    <tr>
                        <td
                            style={{
                                background: "#FFFFFF",
                                borderBottom: "3px solid #005C99",
                                padding: "15px 20px",
                                textAlign: "center"
                            }}
                        >
                            <table
                                style={{
                                    fontFamily: '"Source Sans Pro", sans-serif',
                                    fontSize: 14,
                                    margin: "0 auto",
                                    padding: 0,
                                    border: 0,
                                    textAlign: "left",
                                    borderCollapse: "collapse",
                                    width: "100%",
                                    pageBreakInside: "avoid"
                                }}
                            >
                                <thead>
                                    <tr>
                                        <th style={{ width: 117, verticalAlign: "middle" }}>
                                            <img
                                                src={MIXTLogo}
                                                alt="MIXT Logo"
                                                width={117}
                                                height={40}
                                                style={{ border: 0, display: "block" }}
                                            />
                                        </th>
                                        <th style={{ textAlign: "center", verticalAlign: "middle" }}>
                                            <h1
                                                style={{
                                                    margin: 0,
                                                    fontWeight: "bold",
                                                    fontSize: 24,
                                                    color: "#005C99"
                                                }}
                                            >
                                                Pick List
                                            </h1>
                                        </th>
                                        <th
                                            style={{
                                                width: 117,
                                                textAlign: "right",
                                                verticalAlign: "middle"
                                            }}
                                        >
                                            &nbsp;
                                        </th>
                                    </tr>
                                </thead>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ padding: "20px 20px 0" }}>
                            <table
                                aria-hidden="true"
                                style={{
                                    fontSize: 14,
                                    margin: "0 auto",
                                    padding: 0,
                                    border: 0,
                                    textAlign: "left",
                                    borderCollapse: "collapse",
                                    width: "100%"
                                }}
                            >
                                <tbody>
                                    <tr>
                                        <td style={{ padding: "10px 0" }}>
                                            <table
                                                style={{
                                                    margin: 0,
                                                    padding: 0,
                                                    textAlign: "left",
                                                    borderCollapse: "collapse",
                                                    width: "100%",
                                                    borderColor: "#CCCCCC",
                                                    border: "1px solid #CCCCCC"
                                                }}
                                            >
                                                <tbody>
                                                    <tr>
                                                        <th
                                                            style={{
                                                                fontWeight: "bold",
                                                                padding: "15px 10px",
                                                                verticalAlign: "top",
                                                                textAlign: "center",
                                                                width: '10%',
                                                                whiteSpace: "nowrap",
                                                                border: "1px solid #CCCCCC",
                                                                background: "#E6EFF5"
                                                            }}
                                                        >
                                                            S.No.
                                                        </th>
                                                        <th
                                                            style={{
                                                                fontWeight: "bold",
                                                                padding: "15px 10px",
                                                                verticalAlign: "top",
                                                                textAlign: "left",
                                                                width: '30%',
                                                                whiteSpace: "nowrap",
                                                                border: "1px solid #CCCCCC",
                                                                background: "#E6EFF5"
                                                            }}
                                                        >
                                                            SKU
                                                        </th>
                                                        <th
                                                            style={{
                                                                fontWeight: "bold",
                                                                padding: "15px 10px",
                                                                verticalAlign: "top",
                                                                width: "50%",
                                                                whiteSpace: "nowrap",
                                                                border: "1px solid #CCCCCC",
                                                                background: "#E6EFF5"
                                                            }}
                                                        >
                                                            Product Name
                                                        </th>
                                                        <th
                                                            style={{
                                                                fontWeight: "bold",
                                                                padding: "15px 10px",
                                                                verticalAlign: "top",
                                                                width: "10%",
                                                                textAlign: "right",
                                                                whiteSpace: "nowrap",
                                                                border: "1px solid #CCCCCC",
                                                                background: "#E6EFF5"
                                                            }}
                                                        >
                                                            Qty
                                                        </th>
                                                    </tr>

                                                    {summaryPickList?.map((item: any, index: number) => {
                                                        return <tr key={index}>
                                                            <td
                                                                style={{
                                                                    padding: "4px 10px",
                                                                    textAlign: "center",
                                                                    fontWeight: "normal",
                                                                    border: "1px solid #CCCCCC"
                                                                }}
                                                            >
                                                                {index + 1}
                                                            </td>
                                                            <td
                                                                style={{
                                                                    padding: "4px 10px",
                                                                    textAlign: "left",
                                                                    fontWeight: "normal",
                                                                    border: "1px solid #CCCCCC"
                                                                }}
                                                            >
                                                                {item.master_sku}
                                                            </td>
                                                            <td
                                                                style={{
                                                                    padding: "4px 10px",
                                                                    fontWeight: "normal",
                                                                    border: "1px solid #CCCCCC"
                                                                }}
                                                            >
                                                                {item?.product_name}
                                                            </td>
                                                            <td
                                                                style={{
                                                                    padding: "4px 10px",
                                                                    textAlign: "right",
                                                                    fontWeight: "normal",
                                                                    border: "1px solid #CCCCCC"
                                                                }}
                                                            >
                                                                {item?.total_quantity}
                                                            </td>
                                                        </tr>
                                                    })}
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        {orderPickList && orderPickList.length > 0 && (
            <div style={{ pageBreakBefore: 'always' }}>
                <table
                    aria-hidden="true"
                    style={{
                        fontFamily: '"Source Sans Pro", sans-serif',
                        fontSize: 14,
                        color: "#000000",
                        margin: "10px auto",
                        padding: 0,
                        width: "100%",
                        background: "#FFFFFF",
                        textAlign: "left",
                        borderCollapse: "collapse",
                        border: "1px solid #CCCCCC",
                        maxWidth: "700px",
                        wordBreak: "break-word"
                    }}
                >
                    <tbody>
                        <tr>
                            <td
                                style={{
                                    background: "#FFFFFF",
                                    borderBottom: "3px solid #005C99",
                                    padding: "15px 20px",
                                    textAlign: "center"
                                }}
                            >
                                <table
                                    style={{
                                        fontFamily: '"Source Sans Pro", sans-serif',
                                        fontSize: 14,
                                        margin: "0 auto",
                                        padding: 0,
                                        border: 0,
                                        textAlign: "left",
                                        borderCollapse: "collapse",
                                        width: "100%",
                                        pageBreakInside: "avoid"
                                    }}
                                >
                                    <thead>
                                        <tr>
                                            <th style={{ width: 117, verticalAlign: "middle" }}>
                                                <img
                                                    src={MIXTLogo}
                                                    alt="MIXT Logo"
                                                    width={117}
                                                    height={40}
                                                    style={{ border: 0, display: "block" }}
                                                />
                                            </th>
                                            <th style={{ textAlign: "center", verticalAlign: "middle" }}>
                                                <h1
                                                    style={{
                                                        margin: 0,
                                                        fontWeight: "bold",
                                                        fontSize: 24,
                                                        color: "#005C99"
                                                    }}
                                                >
                                                    Orderwise Pick List
                                                </h1>
                                            </th>
                                            <th
                                                style={{
                                                    width: 117,
                                                    textAlign: "right",
                                                    verticalAlign: "middle"
                                                }}
                                            >
                                                &nbsp;
                                            </th>
                                        </tr>
                                    </thead>
                                </table>
                            </td>
                        </tr>
                        {orderPickList?.map((order: any, orderIndex: number) => (
                            <tr key={orderIndex}>
                                <td style={{ padding: "20px 20px 0" }}>
                                    <table
                                        aria-hidden="true"
                                        style={{
                                            fontSize: 14,
                                            margin: "0 auto",
                                            padding: 0,
                                            border: 0,
                                            textAlign: "left",
                                            borderCollapse: "collapse",
                                            width: "100%"
                                        }}
                                    >
                                        <tbody>
                                            <tr>
                                                <td style={{ padding: "0", textAlign: "left", fontWeight: "normal", width: '150px' }}>
                                                    <div
                                                        style={{
                                                            fontSize: 14,
                                                            fontWeight: "bold",
                                                        }}
                                                    >
                                                        Order #
                                                    </div>
                                                    <div style={{ fontSize: 14 }}>
                                                        {order?.order_number}
                                                    </div>
                                                </td>
                                                <td style={{ padding: "0 10px", textAlign: "left", fontWeight: "normal", width: '200px' }}>
                                                    <div
                                                        style={{
                                                            fontSize: 14,
                                                            fontWeight: "bold",
                                                        }}
                                                    >
                                                        Package Dimensions(H/W/L)
                                                    </div>
                                                    <div style={{ fontSize: 14 }}>
                                                        {order?.package_type === 'multiple' ? 'Multi-package Shipment' : order?.package_type === 'box' ? (order?.height && order?.width && order?.length ? `${order?.height} x ${order?.width} x ${order?.length}` : 'N/A') : 'N/A'}
                                                    </div>
                                                </td>
                                                <td style={{ padding: "0", textAlign: "right", fontWeight: "normal" }}>
                                                    {order?.order_number &&
                                                        <Barcode
                                                            value={order?.order_number}
                                                            width={1}
                                                            height={20}
                                                            fontSize={12}
                                                        />
                                                    }
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{ padding: "10px 0" }} colSpan={3}>
                                                    <table
                                                        style={{
                                                            margin: 0,
                                                            padding: 0,
                                                            textAlign: "left",
                                                            borderCollapse: "collapse",
                                                            width: "100%",
                                                            borderColor: "#CCCCCC",
                                                            border: "1px solid #CCCCCC"
                                                        }}
                                                    >
                                                        <tbody>
                                                            <tr>
                                                                <th
                                                                    style={{
                                                                        fontWeight: "bold",
                                                                        padding: "15px 10px",
                                                                        verticalAlign: "top",
                                                                        textAlign: "center",
                                                                        width: '10%',
                                                                        whiteSpace: "nowrap",
                                                                        border: "1px solid #CCCCCC",
                                                                        background: "#E6EFF5"
                                                                    }}
                                                                >
                                                                    Type
                                                                </th>
                                                                <th
                                                                    style={{
                                                                        fontWeight: "bold",
                                                                        padding: "15px 10px",
                                                                        verticalAlign: "top",
                                                                        textAlign: "left",
                                                                        width: '30%',
                                                                        whiteSpace: "nowrap",
                                                                        border: "1px solid #CCCCCC",
                                                                        background: "#E6EFF5"
                                                                    }}
                                                                >
                                                                    SKU
                                                                </th>
                                                                <th
                                                                    style={{
                                                                        fontWeight: "bold",
                                                                        padding: "15px 10px",
                                                                        verticalAlign: "top",
                                                                        width: "50%",
                                                                        whiteSpace: "nowrap",
                                                                        border: "1px solid #CCCCCC",
                                                                        background: "#E6EFF5"
                                                                    }}
                                                                >
                                                                    Product Name
                                                                </th>
                                                                <th
                                                                    style={{
                                                                        fontWeight: "bold",
                                                                        padding: "15px 10px",
                                                                        verticalAlign: "top",
                                                                        width: "10%",
                                                                        textAlign: "right",
                                                                        whiteSpace: "nowrap",
                                                                        border: "1px solid #CCCCCC",
                                                                        background: "#E6EFF5"
                                                                    }}
                                                                >
                                                                    Qty
                                                                </th>
                                                            </tr>

                                                            {order?.items?.map((item: any, index: number) => {
                                                                return (
                                                                    <React.Fragment key={index}>
                                                                        <tr>
                                                                            <td
                                                                                style={{
                                                                                    padding: "4px 10px",
                                                                                    textAlign: "center",
                                                                                    fontWeight: "normal",
                                                                                    border: "1px solid #CCCCCC"
                                                                                }}
                                                                            >
                                                                                <span
                                                                                    title={item?.type || 'Core'}
                                                                                    style={{
                                                                                        display: "inline-block",
                                                                                        verticalAlign: "middle",
                                                                                    }}
                                                                                >
                                                                                    {item?.type === 'Bundle' ? <MdInventory2 size={20} /> : SvgIcons.package2Icon}
                                                                                </span>
                                                                            </td>
                                                                            <td
                                                                                style={{
                                                                                    padding: "4px 10px",
                                                                                    textAlign: "left",
                                                                                    fontWeight: "normal",
                                                                                    border: "1px solid #CCCCCC"
                                                                                }}
                                                                            >
                                                                                {item.master_sku}
                                                                            </td>
                                                                            <td
                                                                                style={{
                                                                                    padding: "4px 10px",
                                                                                    fontWeight: "normal",
                                                                                    border: "1px solid #CCCCCC"
                                                                                }}
                                                                            >
                                                                                {item?.product_name}
                                                                            </td>
                                                                            <td
                                                                                style={{
                                                                                    padding: "4px 10px",
                                                                                    textAlign: "right",
                                                                                    fontWeight: "normal",
                                                                                    border: "1px solid #CCCCCC"
                                                                                }}
                                                                            >
                                                                                {item?.quantity}
                                                                            </td>
                                                                        </tr>
                                                                        {/* Render children items if bundle has children */}
                                                                        {item?.children?.map((child: any, childIndex: number) => (
                                                                            <tr key={`${index}-child-${childIndex}`}>
                                                                                <td
                                                                                    style={{
                                                                                        padding: "4px 10px",
                                                                                        textAlign: "center",
                                                                                        fontWeight: "normal",
                                                                                        border: "1px solid #CCCCCC"
                                                                                    }}
                                                                                >
                                                                                    <span
                                                                                        style={{
                                                                                            display: "inline-block",
                                                                                            verticalAlign: "middle",
                                                                                            color: "#005C99"
                                                                                        }}
                                                                                    >
                                                                                        {SvgIcons.replyIcon}
                                                                                    </span>
                                                                                </td>
                                                                                <td
                                                                                    style={{
                                                                                        padding: "4px 10px",
                                                                                        textAlign: "left",
                                                                                        fontWeight: "normal",
                                                                                        border: "1px solid #CCCCCC"
                                                                                    }}
                                                                                >
                                                                                    {child.master_sku}
                                                                                </td>
                                                                                <td
                                                                                    style={{
                                                                                        padding: "4px 10px",
                                                                                        fontWeight: "normal",
                                                                                        border: "1px solid #CCCCCC"
                                                                                    }}
                                                                                >
                                                                                    {child?.product_name}
                                                                                </td>
                                                                                <td
                                                                                    style={{
                                                                                        padding: "4px 10px",
                                                                                        textAlign: "right",
                                                                                        fontWeight: "normal",
                                                                                        border: "1px solid #CCCCCC"
                                                                                    }}
                                                                                >
                                                                                    {child?.quantity}
                                                                                </td>
                                                                            </tr>
                                                                        ))}
                                                                    </React.Fragment>
                                                                );
                                                            })}
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                            {orderIndex < orderPickList.length - 1 && (
                                                <tr>
                                                    <td colSpan={3} style={{ padding: 0, borderBottom: "1px solid #CCC" }}>&nbsp;</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        )}
    </>;
}

export default PrintPickList;